import type { FlotiqStoreApiItem } from "@jti/fe-common";

export const getTransformedMarkers = (items: FlotiqStoreApiItem[]) =>
  items.map((marker: FlotiqStoreApiItem) => {
    const { Street, ZipCode, PhoneNumber, City } = marker.item;
    const address = [Street, City, ZipCode, PhoneNumber].filter(Boolean).join(", ");
    return {
      ...marker.item,
      address,
    };
  });
